import {Injectable} from '@angular/core';
import {HttpService} from '../http.service';

/**
 * API endpoints for managing a shopping cart.
 */
@Injectable({
	providedIn: 'root'
})
export class CartApi extends HttpService {

	/**
	 * Adds the product with the given ID to the shopping cart.
	 * Returns true when successful, otherwise false.
	 */
	async add(productID: string): Promise<boolean> {
		return await this.post<boolean>('cart/' + productID);
	}

	/**
	 * Removes the product with the given ID from the shopping cart.
	 * Returns true when successful, otherwise false.
	 */
	async remove(productID: string): Promise<boolean> {
		return await this.delete<boolean>('cart/' + productID);
	}

	/**
	 * Clears the shopping cart.
	 */
	async clear():Promise<void>{
		return await this.delete<void>('cart');
	}

}
